import React, { Component } from "react"
import { connect } from 'react-redux'

import {msg} from '../Notifications/MsgBox';

class UploadRadio extends Component {

    constructor(props) {
        super(props)
        this.state = {
        };
    }

    componentDidMount() {
        
    }

    componentWillReceiveProps(nextProps) {

    }

    openUploadModal() {
        const { modalId,transaction_no,file_category,defaultFileName,approver_id } = this.props;
        if(transaction_no)
        {
            if (approver_id){
            window.$(`#filename_${file_category}`).val(defaultFileName);
            window.$(`#file_${file_category}`).val('');
            window.$(`#${modalId}`).modal('show');
            }
            else 
            {
                msg.error("กรุณาเลือกผู้อนุมัติ PO ก่อน อัพโหลดไฟล์")
            }
        }
        else{
            msg.error("กรุณาบันทึกรายการก่อน อัพโหลดไฟล์")
        }

    }

    onUploadComplete()
    {
    }
    onUploadCancel()
    {
    }

    render() {
        const { modalId,transaction_no,viewMode } = this.props;
            return (
                <>
                <label className={`radiocontainer ${viewMode?'':'clickable'}`}
                >{this.props.lableName}
                    <input
                        type="radio"
                        id={this.props.name}
                        name= {this.props.name} //{"approve_status"+ index}
                        value = {this.props.value}
                        defaultValue={this.props.defaultValue}  //"N"
                        checked={(this.props.value === 'N')}
                        onChange={this.props.onChange} //{(event) => { this.handleCangeApprove(event, index) }}
                        ref={this.props.genaral_evaluation_ref}
                        disabled={this.props.disabled}
                        onClick={() => this.openUploadModal()}
                    />
                    <span className="checkmark" />
                </label>               
                </>
                // <a href="#" data-toggle="modal" className="sp-bt-addmore" onClick={() => this.openUploadModal()}>
                //     <i className="icon btn-order-savedraft" />
                //     <span className="sp-btn-icon-label">แนบเอกสารที่เกี่ยวข้อง</span>
                //     {/* <span>Transaction No. : { transaction_no }</span> */}
                // </a>
            )
    
            }
        }

export default UploadRadio